/* BRAND KIT – behaviour for all bk-* sections (header, product, galleries, carousels, cart).
   Several sections load this file; the guard makes it run once. */
(function () {
  'use strict';
  if (window.BK) return;
  var BK = (window.BK = {});
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var I18N = window.BK_T || {};
  function T(k, f) { return I18N[k] || f; }
  BK.t = T;
  function rtl(el) { return getComputedStyle(el || document.documentElement).direction === 'rtl'; }
  function qs(s, el) { return (el || document).querySelector(s); }
  function qsa(s, el) { return Array.prototype.slice.call((el || document).querySelectorAll(s)); }
  function lock(on) { document.body.classList.toggle('bk-locked', !!on); }

  function formatMoney(cents, format) {
    cents = Number(cents) || 0;
    format = format || '${{amount}}';
    var re = /\{\{\s*(\w+)\s*\}\}/;
    function fmt(n, p, t, d) {
      t = t === undefined ? ',' : t; d = d === undefined ? '.' : d;
      var parts = (n / 100).toFixed(p).split('.');
      return parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + t) + (parts[1] ? d + parts[1] : '');
    }
    var m = format.match(re), v;
    switch (m ? m[1] : 'amount') {
      case 'amount_no_decimals': v = fmt(cents, 0); break;
      case 'amount_with_comma_separator': v = fmt(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': v = fmt(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': v = fmt(cents, 2, "'", '.'); break;
      case 'amount_no_decimals_with_space_separator': v = fmt(cents, 0, ' ', ''); break;
      case 'amount_with_space_separator': v = fmt(cents, 2, ' ', ','); break;
      case 'amount_with_period_and_space_separator': v = fmt(cents, 2, ' ', '.'); break;
      default: v = fmt(cents, 2);
    }
    var formatted = format.replace(re, v);
var temp = document.createElement('span');
temp.innerHTML = formatted;
return temp.textContent || '';
  }
  BK.formatMoney = formatMoney;

  /* ------------------------------------------------------------------ cart */
  function drawer() { return document.querySelector('cart-drawer'); }
  function setCount(n) {
    qsa('[data-bk-cart-count]').forEach(function (el) { el.textContent = n; el.classList.toggle('is-visible', n > 0); });
  }
  function refreshCount() {
    return fetch(root + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); }).then(function (c) { setCount(c.item_count || 0); }).catch(function () {});
  }
  function openCart(trigger) {
    var d = drawer();
    if (d && typeof d.open === 'function' && (!d.hasValidMarkup || d.hasValidMarkup())) { d.open(trigger); return true; }
    return false;
  }
  function addToCart(body, trigger) {
    var d = drawer();
    var sections = 'cart-drawer,cart-icon-bubble';
    var init = { method: 'POST', credentials: 'same-origin', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' } };
    if (body instanceof FormData) {
      if (d) { body.append('sections', sections); body.append('sections_url', window.location.pathname); }
      init.body = body;
    } else {
      var payload = { items: body };
      if (d) { payload.sections = sections; payload.sections_url = window.location.pathname; }
      init.headers['Content-Type'] = 'application/json';
      init.body = JSON.stringify(payload);
    }
    return fetch(root + 'cart/add.js', init)
      .then(function (r) {
        return r.json().then(function (data) {
          if (!r.ok || data.status) {
            var msg = typeof data.description === 'string' ? data.description : (data.message || T('could_not_add', 'Could not add this item.'));
            throw new Error(msg);
          }
          return data;
        });
      })
      .then(function (data) {
        if (d && typeof d.renderContents === 'function') {
          if (trigger && typeof d.setActiveElement === 'function') d.setActiveElement(trigger);
          return Promise.resolve(d.renderContents(data)).then(function () { refreshCount(); return data; });
        }
        window.location.href = (window.routes && window.routes.cart_url) || root + 'cart';
        return data;
      });
  }
  BK.addToCart = addToCart;

  /* ---------------------------------------------------------------- header */
  function initHeader(h) {
    if (h.dataset.bkReady) return; h.dataset.bkReady = '1';
    var section = h.parentElement;
    var sticky = section && getComputedStyle(section).position === 'sticky';
    var openName = null, last = null;

    function metrics() {
      if (sticky) document.documentElement.style.setProperty('--bk-sticky-top', h.offsetHeight + 'px');
    }
    function onScroll() { h.classList.toggle('is-scrolled', window.scrollY > 8); }
    metrics(); onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', metrics);

    function panel(n) { return qs('[data-bk-panel="' + n + '"]', h); }
    function close() {
      if (!openName) return;
      var p = panel(openName), o = qs('[data-bk-overlay="' + openName + '"]', h);
      if (p) { p.classList.remove('is-open'); p.setAttribute('aria-hidden', 'true'); if ('inert' in p) p.inert = true; }
      if (o) o.classList.remove('is-open');
      qsa('[data-bk-open="' + openName + '"]', h).forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
      openName = null; lock(false);
      if (last) try { last.focus(); } catch (e) {}
    }
    function open(n, trigger) {
      if (openName === n) { close(); return; }
      close();
      var p = panel(n); if (!p) return;
      openName = n; last = trigger;
      if ('inert' in p) p.inert = false; p.removeAttribute('inert');
      p.classList.add('is-open'); p.setAttribute('aria-hidden', 'false');
      var o = qs('[data-bk-overlay="' + n + '"]', h); if (o) o.classList.add('is-open');
      if (trigger) trigger.setAttribute('aria-expanded', 'true');
      if (n === 'menu') lock(true);
      setTimeout(function () { var f = qs(n === 'search' ? 'input[type="search"]' : 'a[href], button', p); if (f) f.focus(); }, 80);
    }
    h.addEventListener('click', function (e) {
      var o = e.target.closest('[data-bk-open]');
      if (o) { e.preventDefault(); open(o.getAttribute('data-bk-open'), o); return; }
      if (e.target.closest('[data-bk-close]')) { e.preventDefault(); close(); return; }
      if (e.target.matches('[data-bk-overlay]') || e.target.matches('[data-bk-backdrop]')) { close(); return; }
      var c = e.target.closest('[data-bk-cart-open]');
      if (c && openCart(c)) e.preventDefault();
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });

    var bubble = document.getElementById('cart-icon-bubble');
    if (bubble && window.MutationObserver) new MutationObserver(refreshCount).observe(bubble, { childList: true, subtree: true });
    if (typeof window.subscribe === 'function' && window.PUB_SUB_EVENTS) window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, refreshCount);
  }

  /* anchors to the buy box should account for the sticky header */
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href="#bk-buy"], a[href="#bk-reviews"], a[href="#bk-faq"]');
    if (!a) return;
    var t = document.querySelector(a.getAttribute('href'));
    if (!t) return;
    e.preventDefault();
    var off = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--bk-sticky-top'), 10) || 0;
    window.scrollTo({ top: t.getBoundingClientRect().top + window.scrollY - off - 16, behavior: reduce ? 'auto' : 'smooth' });
  });

  /* ----------------------------------------------------------- announcement */
  function initAnnounce(el) {
    if (el.dataset.bkReady) return; el.dataset.bkReady = '1';
    var slides = qsa('.bk-announce__slide', el);
    if (slides.length < 2) return;
    var i = 0;
    setInterval(function () {
      slides[i].classList.remove('is-active');
      i = (i + 1) % slides.length;
      slides[i].classList.add('is-active');
    }, 4200);
  }

  /* ---------------------------------------------------------------- gallery */
  function initGallery(el) {
    if (!el) return null;
    var track = qs('[data-bk-track]', el);
    if (!track) return null;
    var slides = qsa('.bk-gallery__slide', track);
    var thumbs = qsa('.bk-gallery__thumb', el);
    var dots = qsa('.bk-gallery__dot', el);
    function isGrid() { return getComputedStyle(track).display === 'grid'; }
    function index() { return track.clientWidth ? Math.round(Math.abs(track.scrollLeft) / track.clientWidth) : 0; }
    function mark(i) {
      thumbs.forEach(function (t, ti) { t.classList.toggle('is-active', ti === i); });
      dots.forEach(function (d, di) { d.classList.toggle('is-active', di === i); });
    }
    function go(i, instant) {
      i = Math.max(0, Math.min(slides.length - 1, i));
      if (isGrid()) { slides[i].scrollIntoView({ behavior: reduce || instant ? 'auto' : 'smooth', block: 'center' }); mark(i); return; }
      track.scrollTo({ left: (rtl(track) ? -1 : 1) * i * track.clientWidth, behavior: reduce || instant ? 'auto' : 'smooth' });
      mark(i);
    }
    var t;
    track.addEventListener('scroll', function () { clearTimeout(t); t = setTimeout(function () { mark(index()); }, 60); }, { passive: true });
    thumbs.concat(dots).forEach(function (b) { b.addEventListener('click', function () { go(Number(b.getAttribute('data-index'))); }); });
    qsa('[data-bk-step]', el).forEach(function (b) { b.addEventListener('click', function () { var n = index() + Number(b.getAttribute('data-bk-step')); go(n < 0 ? slides.length - 1 : n >= slides.length ? 0 : n); }); });
    return {
      index: function () { return isGrid() ? 0 : index(); },
      go: go,
      toMedia: function (id) {
        var s = slides.filter(function (x) { return x.getAttribute('data-media-id') === String(id); })[0];
        if (s) go(Number(s.getAttribute('data-index')));
      }
    };
  }

  function initLightbox(dialog, gallery) {
    if (!dialog || typeof dialog.showModal !== 'function') return null;
    var slides = qsa('.bk-lightbox__slide', dialog);
    var count = qs('[data-bk-lb-count]', dialog);
    var i = 0;
    function show(n) {
      i = (n + slides.length) % slides.length;
      slides.forEach(function (s, si) { s.hidden = si !== i; var im = qs('img', s); if (im) im.classList.remove('is-zoomed'); });
      if (count) count.textContent = (i + 1) + ' / ' + slides.length;
    }
    dialog.addEventListener('click', function (e) {
      if (e.target.closest('[data-bk-lb-close]')) { dialog.close(); return; }
      var st = e.target.closest('[data-bk-lb-step]'); if (st) { show(i + Number(st.getAttribute('data-bk-lb-step'))); return; }
      var im = e.target.closest('.bk-lightbox__img'); if (im) { im.classList.toggle('is-zoomed'); return; }
      if (e.target.classList.contains('bk-lightbox__slide') || e.target.classList.contains('bk-lightbox__stage')) dialog.close();
    });
    dialog.addEventListener('keydown', function (e) { var d = rtl(dialog) ? -1 : 1; if (e.key === 'ArrowRight') show(i + d); if (e.key === 'ArrowLeft') show(i - d); });
    var sx = null;
    dialog.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
    dialog.addEventListener('touchend', function (e) { if (sx === null) return; var dx = e.changedTouches[0].clientX - sx; if (Math.abs(dx) > 50) show(i + ((dx < 0) !== rtl(dialog) ? 1 : -1)); sx = null; });
    dialog.addEventListener('close', function () { lock(false); if (gallery) gallery.go(i, true); });
    return { open: function (n) { show(n || 0); dialog.showModal(); lock(true); } };
  }


  /* ---------------------------------------------------------------- bundle */
  function initBundle(sec, variants, money, gallery, onPrimary) {
    var el = qs('[data-bk-bundle]', sec);
    if (!el) return null;
    var cfg; try { cfg = JSON.parse(qs('[data-bk-bundle-json]', el).textContent); } catch (e) { return null; }
    var tiers = qsa('.bk-tier', el);
    var tpl = qs('template[data-bk-row-tpl]', el);
    var box = document.createElement('div'); box.className = 'bk-tier__rows';
    box.style.cssText = 'display:flex;flex-direction:column;gap:10px';
    var rows = [];
    var addon = qs('[data-bk-addon]', el);
    var addonVar = qs('[data-bk-addon-variant]', el);
    var addonWrap = addon ? addon.closest('.bk-addon') : null;
    var hasOpts = !!(cfg.options && cfg.options.length && tpl);
    var first = variants.filter(function (v) { return v.available; })[0] || variants[0];
    var start = variants.filter(function (v) { return v.id === cfg.start; })[0] || first;

    function partial(o) { return variants.filter(function (v) { return o.every(function (x, i) { return x === '' || x == null || v.options[i] === x; }); }); }
    function opts(r) { return r.sels.map(function (x) { return x.value; }); }
    function incomplete(r) { return opts(r).some(function (x) { return x === ''; }); }
    function variantOf(r) { if (!hasOpts) return variants[0]; if (!r || incomplete(r)) return null; return partial(opts(r))[0] || null; }
    function priceOf(r) { var v = variantOf(r); if (v) return v.price; var p = r ? partial(opts(r)) : []; return (p[0] || start).price; }
    function tierQty(t) { return Math.max(1, Number(t.getAttribute('data-qty')) || 1); }
    function active() { return tiers.filter(function (t) { return t.classList.contains('is-active'); })[0] || tiers[0]; }
    function swatch(val) { return (cfg.swatches || {})[String(val || '').toLowerCase()] || ''; }

    function paint(r, strict) {
      var o = opts(r), inc = incomplete(r), v = variantOf(r);
      var bad = inc ? !!strict : !(v && v.available);
      r.sels.forEach(function (sel, si) {
        qsa('option', sel).forEach(function (op) {
          if (op.value === '') return;
          var t = o.slice(); t[si] = op.value;
          var any = partial(t).some(function (x) { return x.available; });
          op.textContent = op.getAttribute('data-label') + (any ? '' : ' · ' + T('sold_out_short', 'Sold out'));
        });
        sel.parentElement.classList.toggle('is-invalid', bad && (!inc || sel.value === ''));
      });
      if (cfg.colorIndex > -1 && r.sels[cfg.colorIndex]) {
        var w = r.sels[cfg.colorIndex].parentElement, hex = swatch(o[cfg.colorIndex]), dot = qs('.bk-select__dot', w);
        w.classList.toggle('has-dot', !!hex); if (dot) dot.style.setProperty('--dot', hex || 'transparent');
      }
      return !bad;
    }
    function makeRow(i, o) {
      var row = tpl.content.firstElementChild.cloneNode(true);
      var num = qs('[data-bk-row-num]', row); if (num) num.textContent = cfg.pairWord + ' ' + (i + 1);
      var r = { el: row, sels: qsa('select[data-opt]', row), i: i };
      row.style.setProperty('--cols', Math.max(1, r.sels.length));
      r.sels.forEach(function (sel, si) { if (o && o[si] != null) sel.value = o[si]; if (sel.selectedIndex < 0) sel.selectedIndex = 0; });
      row.addEventListener('change', function (e) {
        paint(r);
        if (cfg.colorIndex > -1 && e.target === r.sels[cfg.colorIndex] && gallery) {
          var any = variants.filter(function (x) { return x.options[cfg.colorIndex] === e.target.value && x.media; })[0];
          if (any) gallery.toMedia(any.media);
        }
        var v = variantOf(r);
        if (r.i === 0 && v) onPrimary(v);
        prices();
      });
      paint(r);
      return r;
    }
    function startOpts() { return start.options.map(function (v, i) { return cfg.force && i !== cfg.colorIndex ? '' : v; }); }
    function layout() {
      var t = active(), n = tierQty(t);
      if (hasOpts) {
        while (rows.length < n) rows.push(makeRow(rows.length, rows.length ? opts(rows[rows.length - 1]) : startOpts()));
        rows.forEach(function (r, ri) { r.el.hidden = ri >= n; if (!r.el.parentNode) box.appendChild(r.el); });
        var slot = qs('[data-bk-tier-items]', t); if (slot && box.parentNode !== slot) slot.appendChild(box);
      }
      prices();
    }
    function addonPrice() {
      if (!addon || !addon.checked) return 0;
      var o = addonVar ? addonVar.options[addonVar.selectedIndex] : null;
      return Number((o && o.getAttribute('data-price')) || addon.getAttribute('data-price') || 0);
    }
    function prices() {
      var act = active(), grand = 0, base = rows.length ? priceOf(rows[0]) : start.price;
      tiers.forEach(function (t) {
        var n = tierQty(t), d = Number(t.getAttribute('data-discount')) || 0, full = 0;
        if (t === act && hasOpts) { for (var i = 0; i < n; i++) full += rows[i] ? priceOf(rows[i]) : base; }
        else full = base * n;
        var now = Math.round(full * (100 - d) / 100);
        var tot = qs('[data-bk-tier-total]', t), was = qs('[data-bk-tier-was]', t), unit = qs('[data-bk-tier-unit]', t);
        if (tot) tot.textContent = formatMoney(now, money);
        if (was) { was.hidden = d <= 0; was.textContent = d > 0 ? formatMoney(full, money) : ''; }
        if (unit) unit.textContent = n > 1 ? formatMoney(Math.round(now / n), money) + ' ' + (cfg.unitWord || '') : '';
        if (t === act) grand = now;
      });
      if (addonWrap) addonWrap.classList.toggle('is-on', !!(addon && addon.checked));
      qsa('[data-bk-btn-total]', sec).forEach(function (x) { x.textContent = formatMoney(grand + addonPrice(), money); });
    }
    function choose(t) {
      tiers.forEach(function (x) { var on = x === t; x.classList.toggle('is-active', on); x.setAttribute('aria-checked', on ? 'true' : 'false'); });
      layout();
    }
    tiers.forEach(function (t) {
      t.addEventListener('click', function (e) { if (e.target.closest('[data-bk-tier-items]')) return; if (!t.classList.contains('is-active')) choose(t); });
      t.addEventListener('keydown', function (e) {
        if (e.target !== t) return;
        if (e.key === ' ' || e.key === 'Enter') { e.preventDefault(); choose(t); }
        var i = tiers.indexOf(t), d = 0;
        if (e.key === 'ArrowDown') d = 1; if (e.key === 'ArrowUp') d = -1;
        if (d) { e.preventDefault(); var nx = tiers[(i + d + tiers.length) % tiers.length]; nx.focus(); choose(nx); }
      });
    });
    if (addon) addon.addEventListener('change', prices);
    if (addonVar) addonVar.addEventListener('change', function () { if (addon) addon.checked = true; prices(); });
    layout();

    return {
      items: function () {
        var n = tierQty(active()), map = {}, order = [], bad = false;
        if (!hasOpts) { map[variants[0].id] = n; order.push(variants[0].id); }
        else for (var i = 0; i < n; i++) {
          var r = rows[i], v = variantOf(r);
          if (!paint(r, true) || !v || !v.available) { bad = true; continue; }
          if (!map[v.id]) { map[v.id] = 0; order.push(v.id); } map[v.id] += 1;
        }
        if (bad) {
          var firstBad = qs('.bk-select.is-invalid select', el); if (firstBad) firstBad.focus();
          return null;
        }
        var items = order.map(function (id) { return { id: id, quantity: map[id] }; });
        if (addon && addon.checked) {
          var aid = addonVar ? Number(addonVar.value) : Number(addon.value);
          if (aid) items.push({ id: aid, quantity: 1 });
        }
        return items;
      },
      pick: function (value) {
        if (cfg.colorIndex < 0 || !rows[0]) return false;
        var sel = rows[0].sels[cfg.colorIndex];
        var hit = qsa('option', sel).filter(function (o) { return o.value.toLowerCase() === String(value).toLowerCase(); })[0];
        if (!hit) return false;
        sel.value = hit.value; sel.dispatchEvent(new Event('change', { bubbles: true }));
        return true;
      }
    };
  }

  /* ---------------------------------------------------------------- product */
  function initProduct(sec) {
    if (sec.dataset.bkReady) return; sec.dataset.bkReady = '1';
    var dataEl = qs('[data-bk-product-json]', sec);
    if (!dataEl) return;
    var data; try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var variants = data.variants || [];
    var money = data.showCurrency ? data.moneyWithCurrencyFormat : data.moneyFormat;
    var form = qs('form[data-bk-form]', sec);
    var idInput = qs('[data-bk-variant-id]', sec);
    var qty = qs('[data-bk-qty-input]', sec);
    var err = qs('[data-bk-error]', sec);
    var addBtn = qs('[data-bk-add]', sec);
    var sticky = qs('[data-bk-sticky]', sec);
    var stickyBtn = qs('[data-bk-sticky-add]', sec);
    var groups = qsa('[data-bk-option]', sec);
    var current = variants.filter(function (v) { return idInput && String(v.id) === idInput.value; })[0] || variants[0];
    var gallery = initGallery(qs('[data-bk-gallery]', sec));
    var lightbox = initLightbox(qs('[data-bk-lightbox]', sec), gallery);
    var bundle = initBundle(sec, variants, data.moneyFormat || money, gallery, function (v) { render(v); });

    function selected() { return groups.map(function (g) { var a = qs('.bk-option__value.is-active', g); return a ? a.getAttribute('data-bk-value') : null; }); }
    function match(opts) { return variants.filter(function (v) { return opts.every(function (o, i) { return o === null || v.options[i] === o; }); }); }
    function availability(opts) {
      groups.forEach(function (g, gi) {
        qsa('.bk-option__value', g).forEach(function (b) {
          var t = opts.slice(); t[gi] = b.getAttribute('data-bk-value');
          b.classList.toggle('is-unavailable', !match(t).some(function (v) { return v.available; }));
        });
      });
    }
    function setPills(opts) {
      groups.forEach(function (g, gi) {
        qsa('.bk-option__value', g).forEach(function (b) {
          var on = b.getAttribute('data-bk-value') === opts[gi];
          b.classList.toggle('is-active', on); b.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        var lbl = qs('[data-bk-option-value]', g); if (lbl) lbl.textContent = opts[gi];
      });
    }
    function render(v) {
      var buttons = [addBtn, stickyBtn].filter(Boolean);
      if (!v) {
        buttons.forEach(function (b) { b.disabled = true; });
        qsa('[data-bk-add-label]', sec).forEach(function (l) { l.textContent = T('unavailable', 'Unavailable'); });
        return;
      }
      current = v;
      if (idInput) idInput.value = v.id;
      var sale = v.compare > v.price;
      qsa('[data-bk-price]', sec).forEach(function (el) { el.textContent = formatMoney(v.price, money); });
      qsa('[data-bk-compare]', sec).forEach(function (el) { el.hidden = !sale; el.textContent = sale ? formatMoney(v.compare, money) : ''; });
      qsa('[data-bk-badge]', sec).forEach(function (el) {
        el.hidden = !sale; if (!sale) return;
        var mode = el.getAttribute('data-mode');
        if (mode === 'percent') el.textContent = '-' + Math.floor(((v.compare - v.price) * 100) / v.compare) + '%';
        else if (mode === 'amount') el.textContent = T('save', 'Save') + ' ' + formatMoney(v.compare - v.price, data.moneyFormat);
        else el.textContent = el.getAttribute('data-text');
      });
      buttons.forEach(function (b) { b.disabled = !v.available; });
      qsa('[data-bk-add-label]', sec).forEach(function (l) { l.textContent = v.available ? l.getAttribute('data-add') : T('sold_out', 'Sold out'); });
      var stock = qs('[data-bk-stock]', sec);
      if (stock) {
        var th = Number(stock.getAttribute('data-threshold')), sc = Number(stock.getAttribute('data-scale'));
        var show = v.managed && v.qty > 0 && v.qty <= th;
        stock.hidden = !show;
        if (show) {
          var q = qs('[data-bk-stock-qty]', stock); if (q) q.textContent = v.qty;
          var f = qs('[data-bk-stock-fill]', stock); if (f) f.style.width = Math.max(6, Math.min(100, v.qty * 100 / sc)) + '%';
        }
      }
      var si = qs('.bk-sticky__img', sec); if (si && v.image) { si.removeAttribute('srcset'); si.src = v.image; }
      if (v.media && gallery) gallery.toMedia(v.media);
      try { var u = new URL(window.location.href); u.searchParams.set('variant', v.id); window.history.replaceState({}, '', u.toString()); } catch (e) {}
    }

    sec.addEventListener('click', function (e) {
      var b = e.target.closest('.bk-option__value');
      if (b) {
        var gi = Number(b.getAttribute('data-option-index'));
        var opts = selected(); opts[gi] = b.getAttribute('data-bk-value');
        var v = match(opts)[0];
        if (!v || !v.available) {
          var alt = variants.filter(function (x) { return x.options[gi] === opts[gi] && x.available; })[0];
          if (alt) { v = alt; opts = alt.options.slice(); }
        }
        setPills(opts); availability(opts); render(v);
        return;
      }
      var st = e.target.closest('[data-bk-qty-step]');
      if (st && qty) { qty.value = Math.max(1, (parseInt(qty.value, 10) || 1) + Number(st.getAttribute('data-bk-qty-step'))); return; }
      if (e.target.closest('[data-bk-lightbox-open]') && lightbox) { lightbox.open(gallery ? gallery.index() : 0); return; }
      var slide = e.target.closest('.bk-gallery__slide');
      if (slide && lightbox && !e.target.closest('video, iframe, model-viewer')) lightbox.open(Number(slide.getAttribute('data-index')) || 0);
    });

    function busy(on) {
      [addBtn, stickyBtn].filter(Boolean).forEach(function (b) { b.setAttribute('aria-busy', on ? 'true' : 'false'); b.disabled = on || (!bundle && !(current && current.available)); });
    }
    function submit(trigger) {
      if (bundle) {
        var items = bundle.items();
        if (err) err.textContent = items ? '' : T('choose_options', 'Please choose an available option for every item.');
        if (!items) return;
        busy(true);
        addToCart(items, trigger).catch(function (e) { if (err) err.textContent = e.message; }).then(function () { busy(false); });
        return;
      }
      if (!current || !current.available) return;
      if (err) err.textContent = '';
      busy(true);
      var body = form ? new FormData(form) : [{ id: current.id, quantity: 1 }];
      addToCart(body, trigger).catch(function (e) { if (err) err.textContent = e.message; else console.warn(e.message); }).then(function () { busy(false); });
    }
    if (form) form.addEventListener('submit', function (e) { e.preventDefault(); submit(e.submitter || addBtn); });
    if (stickyBtn) stickyBtn.addEventListener('click', function () { submit(stickyBtn); });

    var watch = addBtn || qs('.bk-product__info', sec);
    if (sticky && watch && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          var past = !en.isIntersecting && en.boundingClientRect.top < 0;
          sticky.classList.toggle('is-visible', past);
          sticky.setAttribute('aria-hidden', past ? 'false' : 'true');
          qsa('button', sticky).forEach(function (b) { b.tabIndex = past ? 0 : -1; });
        });
      }).observe(watch);
    }

    var del = qs('[data-bk-delivery]', sec);
    if (del) {
      var out = qs('[data-bk-delivery-dates]', del);
      var lang = document.documentElement.getAttribute('lang') || 'en';
      var f = function (d) { try { return d.toLocaleDateString(lang, { month: 'short', day: 'numeric' }); } catch (e) { return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' }); } };
      var now = Date.now();
      if (out) out.textContent = f(new Date(now + Number(del.getAttribute('data-min')) * 864e5)) + ' – ' + f(new Date(now + Number(del.getAttribute('data-max')) * 864e5));
    }
    if (groups.length) availability(selected());

    sec.bkPick = function (value) {
      if (bundle && bundle.pick(value)) return true;
      var b = qsa('.bk-option__value', sec).filter(function (x) { return x.getAttribute('data-bk-value').toLowerCase() === String(value).toLowerCase(); })[0];
      if (b) { b.click(); return true; }
      return false;
    };
    sec.addEventListener('click', function (e) {
      var so = e.target.closest('[data-bk-size-open]');
      if (!so) return;
      e.preventDefault();
      var acc = qs('[data-bk-size-guide]', sec);
      if (!acc) return;
      acc.open = true; acc.classList.remove('is-flash'); void acc.offsetWidth; acc.classList.add('is-flash');
      var off = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--bk-sticky-top'), 10) || 0;
      window.scrollTo({ top: acc.getBoundingClientRect().top + window.scrollY - off - 20, behavior: reduce ? 'auto' : 'smooth' });
    });
  }

  /* --------------------------------------------------------------- carousels */
  function initCarousel(sec) {
    if (sec.dataset.bkCarReady) return;
    var track = qs('[data-bk-carousel-track]', sec);
    if (!track) return;
    sec.dataset.bkCarReady = '1';
    var btns = qsa('[data-bk-carousel-step]', sec);
    function update() {
      var max = track.scrollWidth - track.clientWidth - 2;
      btns.forEach(function (b) {
        var dir = Number(b.getAttribute('data-bk-carousel-step'));
        var x = Math.abs(track.scrollLeft);
        b.disabled = dir < 0 ? x <= 2 : x >= max;
      });
      var nav = btns[0] && btns[0].parentElement;
      if (nav) nav.style.display = track.scrollWidth <= track.clientWidth + 4 ? 'none' : '';
    }
    btns.forEach(function (b) {
      b.addEventListener('click', function () {
        var item = track.firstElementChild;
        var w = item ? item.getBoundingClientRect().width + 18 : track.clientWidth * .8;
        track.scrollBy({ left: (rtl(track) ? -1 : 1) * Number(b.getAttribute('data-bk-carousel-step')) * w, behavior: reduce ? 'auto' : 'smooth' });
      });
    });
    track.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  function initRelated(sec) {
    if (sec.dataset.bkRelReady) return; sec.dataset.bkRelReady = '1';
    if (sec.hasAttribute('data-loaded')) { initCarousel(sec); return; }
    var url = sec.getAttribute('data-url');
    if (!url) return;
    fetch(url, { credentials: 'same-origin' }).then(function (r) { return r.text(); }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = qs('[data-bk-related]', doc);
      if (!fresh || !qs('.bk-related__slide', fresh)) { sec.setAttribute('data-empty', ''); return; }
      sec.innerHTML = fresh.innerHTML;
      sec.removeAttribute('data-empty');
      initCarousel(sec);
    }).catch(function () { sec.setAttribute('data-empty', ''); });
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-bk-quick-add]');
    if (!b) return;
    e.preventDefault();
    var label = qs('.bk-btn__label', b), txt = label ? label.textContent : '';
    b.setAttribute('aria-busy', 'true'); if (label) label.textContent = T('adding', 'Adding…');
    addToCart([{ id: Number(b.getAttribute('data-bk-quick-add')), quantity: 1 }], b)
      .catch(function (er) { console.warn('[brand kit] ' + er.message); })
      .then(function () { b.setAttribute('aria-busy', 'false'); if (label) label.textContent = txt; });
  });


  /* -------------------------------------------------- colour cards → buy box */
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-bk-pick]');
    if (!b) return;
    e.preventDefault();
    var p = qs('[data-bk-product]');
    if (p && typeof p.bkPick === 'function') p.bkPick(b.getAttribute('data-bk-pick'));
    var t = qs('#bk-buy');
    if (t) {
      var off = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--bk-sticky-top'), 10) || 0;
      window.scrollTo({ top: t.getBoundingClientRect().top + window.scrollY - off - 16, behavior: reduce ? 'auto' : 'smooth' });
    }
  });

  /* ------------------------------------------------------------ hotspots */
  function initHot(sec) {
    if (sec.dataset.bkReady) return; sec.dataset.bkReady = '1';
    var dots = qsa('[data-bk-hot-dot]', sec), items = qsa('[data-bk-hot-item]', sec);
    function act(i) {
      dots.forEach(function (d, di) { d.classList.toggle('is-active', di === i); d.setAttribute('aria-pressed', di === i ? 'true' : 'false'); });
      items.forEach(function (it, ii) { it.classList.toggle('is-active', ii === i); });
    }
    dots.forEach(function (d, i) { d.addEventListener('click', function () { act(i); }); d.addEventListener('mouseenter', function () { act(i); }); });
    items.forEach(function (it, i) { it.addEventListener('mouseenter', function () { act(i); }); });
    if (dots.length) act(0);
  }

  /* -------------------------------------------------------------- reviews */
  function initReviews(sec) {
    if (sec.dataset.bkReady) return; sec.dataset.bkReady = '1';
    var cards = qsa('[data-bk-rv-card]', sec), chips = qsa('[data-bk-rv-filter]', sec);
    var more = qs('[data-bk-rv-more]', sec), page = Number(sec.getAttribute('data-page')) || 6, shown = page, filter = 'all';
    function ok(c) {
      if (filter === 'all') return true;
      if (filter === 'photos') return c.hasAttribute('data-photo');
      if (filter.indexOf('stars:') === 0) return c.getAttribute('data-stars') === filter.slice(6);
      if (filter.indexOf('role:') === 0) return c.getAttribute('data-role') === filter.slice(5);
      return true;
    }
    function apply() {
      var n = 0, total = 0;
      cards.forEach(function (c) { var m = ok(c); if (m) total++; c.hidden = !m || n >= shown; if (m && n < shown) n++; });
      if (more) more.hidden = total <= shown;
    }
    chips.forEach(function (ch) {
      ch.addEventListener('click', function () {
        filter = ch.getAttribute('data-bk-rv-filter'); shown = page;
        chips.forEach(function (x) { var on = x === ch; x.classList.toggle('is-active', on); x.setAttribute('aria-pressed', on ? 'true' : 'false'); });
        apply();
      });
    });
    if (more) more.addEventListener('click', function () { shown += page; apply(); });
    var zoom = qs('[data-bk-rv-zoom]', sec);
    if (zoom && typeof zoom.showModal === 'function') {
      var zi = qs('img', zoom);
      sec.addEventListener('click', function (e) {
        var ph = e.target.closest('[data-bk-rv-photo]');
        if (ph) { zi.src = ph.getAttribute('data-bk-rv-photo'); zi.alt = ''; zoom.showModal(); return; }
        if (e.target === zoom || e.target.closest('[data-bk-rv-close]')) zoom.close();
      });
    }
    apply();
  }

  /* rating next to the title, filled from the reviews on this page */
  function fillRatings() {
    var sum = qs('[data-bk-reviews-summary]');
    var n = sum ? Number(sum.getAttribute('data-count')) : 0;
    if (!n) return;
    var avg = sum.getAttribute('data-avg');
    qsa('[data-bk-rating-auto]').forEach(function (r) {
      var f = qs('.bk-stars__front', r); if (f) f.style.width = Math.min(100, Number(avg) * 20) + '%';
      var t = qs('[data-bk-rating-text]', r); if (t) t.textContent = avg + ' · ' + n + ' ' + (n === 1 ? T('review', 'review') : T('reviews', 'reviews'));
      r.hidden = false;
    });
  }

  /* ------------------------------------------------------------- fit text */
  function fitAll() {
    qsa('[data-bk-fit]').forEach(function (el) {
      var span = el.firstElementChild; if (!span) return;
      el.style.fontSize = '';
      var max = parseFloat(getComputedStyle(el).fontSize);
      var ratio = el.clientWidth / span.scrollWidth;
      if (ratio < 1) el.style.fontSize = Math.floor(max * ratio * 0.98) + 'px';
    });
  }
  window.addEventListener('resize', fitAll);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(fitAll);

  /* ------------------------------------------------------------------- init */
  function init(scope) {
    scope = scope || document;
    qsa('[data-bk-header]', scope).forEach(initHeader);
    qsa('[data-bk-announce]', scope).forEach(initAnnounce);
    qsa('[data-bk-product]', scope).forEach(initProduct);
    qsa('[data-bk-related]', scope).forEach(initRelated);
    qsa('[data-bk-carousel]', scope).forEach(function (s) { if (!s.hasAttribute('data-bk-related')) initCarousel(s); });
    qsa('[data-bk-hot]', scope).forEach(initHot);
    qsa('[data-bk-rv]', scope).forEach(initReviews);
    fillRatings();
    fitAll();
  }
  BK.init = init;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
